



































































import { Component, Vue, Watch } from 'vue-property-decorator';
import '../css/card.less';
import api_data from '@/Api/api_data';
import MessageBus from '@/Utils/message/message-bus';
import Card from './card.vue';
import API from '@/Api/api_simulaion';
import { delayedPromise } from '@/Utils/promise-utils';
import { DataLoad } from '@/Utils/decorator/data-load';
import Tools from '@/component/template/tools/tools';
import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';

const DefaultEnergyAnalysisData = {
    data: {
        totalPowerSypply: 0,
        totalPowerLoad: 0,
        totalPowerLoss: 0,
        totalHeatSupply: 0,
        totalHeatLoad: 0,
        totalHeatLoss: 0,
        totalCoolSupply: 0,
        totalCoolLoad: 0,
        totalCoolLoss: 0,
        totalSteamSupply: 0,
        totalSteamLoad: 0,
        totalSteamLoss: 0,
        energyEfficiency: 0,
        renewableEnergyRatio: 0,
        tableData: {
            year: {} as Record<string, { cool: number[]; heat: number[]; power: number[]; steam: number[] }>,
            month: {} as Record<string, { cool: number[][]; heat: number[][]; power: number[][]; steam: number[][] }>,
        },
        startYear: '',
    },
};

/**
 * @author guan
 * @description 能效分析结果
 */
@Component({
    components: {
        Card,
    },
})
export default class EnergyEfficiency extends Vue {
    /** disabledFunction */
    disabledFunction = ieslabDisableRules;
    /** 加载状态 */
    spinningStatus = true;
    /** */
    energyAnalysisData: typeof DefaultEnergyAnalysisData = JSON.parse(JSON.stringify(DefaultEnergyAnalysisData));
    /** */
    signTime = 0;
    /**卡片构造体*/
    /** */
    cardStruct = [
        {
            icon: 'iconfangan',
            title: '电',
            map: {
                总供电: 'totalPowerSypply',
                总用电: 'totalPowerLoad',
                网耗: 'totalPowerLoss',
            },
            type: 0,
        },
        {
            icon: 'iconfangan',
            title: '热',
            map: {
                总供热: 'totalHeatSupply',
                总用热: 'totalHeatLoad',
                网耗: 'totalHeatLoss',
            },
            type: 0,
        },
        {
            icon: 'iconfangan',
            title: '冷',
            map: {
                总供冷: 'totalCoolSupply',
                总用冷: 'totalCoolLoad',
                网耗: 'totalCoolLoss',
            },
            type: 0,
        },
        // {
        //     icon: 'iconfangan',
        //     title: '汽',
        //     map: {
        //         总供汽: 'totalSteamSupply',
        //         总用汽: 'totalSteamLoad',
        //         网耗: 'totalSteamLoss',
        //     },
        //     type: 0,
        // },
        {
            icon: 'iconfangan',
            title: '能效水平',
            map: {
                能效水平: 'energyEfficiency',
            },
            type: 1,
            background: '#5982fb',
            color: '#fff',
        },
        {
            icon: 'iconfangan',
            title: '可再生能源利用比例',
            map: {
                可再生能源利用比例: 'renewableEnergyRatio',
            },

            color: '#fff',
            background: '#9a81ff',
            type: 1,
        },
    ];

    /** */
    monthIndex: null | number = null;

    /**
     *getEnergyAnalysisData
     */
    getEnergyAnalysisData(key: string): string {
        return this.energyAnalysisData['data'][key].toFixed(2);
    }
    /**
     *
     */
    getTableData(equipmentName: string, yearIndex: number, monthIndex?: number): number[] {
        const energyTypeList = ['power', 'heat', 'cool'];
        if (monthIndex == null) {
            return energyTypeList.map((energyKey) => this.energyAnalysisData['data']['tableData'].year[equipmentName][energyKey][yearIndex]);
        } else {
            return energyTypeList.map((energyKey) => this.energyAnalysisData['data']['tableData'].month[equipmentName][energyKey][yearIndex][monthIndex]);
        }
    }

    /**
     *获取设备列表
     */
    get equipmentsList(): string[] {
        return Object.keys(this.energyAnalysisData['data']['tableData'].year);
    }

    /**
     *
     */
    get yearList(): number[] {
        if (Object.values(this.energyAnalysisData.data.tableData.year).length === 0) {
            return [];
        }
        const startYear = Number(this.energyAnalysisData.data.startYear);
        const yearSpan = Object.values(this.energyAnalysisData.data.tableData.year)[0].cool.length;
        return new Array<number>(yearSpan).fill(0).map((item, index) => index + startYear);
    }

    /**
     *
     */
    async exportToFile(): Promise<void> {
        //总数据
        const totalSheetData: Array<Array<string | number>> = [[''], [''], [''], [''], ['']];
        totalSheetData[0] = ['能源类型', '总供量', '总用量', '网耗'];
        this.cardStruct.forEach((item, index) => {
            if (index > 3) {
                return;
            }
            totalSheetData[index + 1][0] = item.title;
            totalSheetData[index + 1] = totalSheetData[index + 1].concat(Object.values(item.map).map((item) => this.energyAnalysisData.data[item as string]));
        });
        const sheetsData = [{ name: '总数据', data: totalSheetData }];

        //年份数据
        const startYear = Number(this.energyAnalysisData.data.startYear);
        const yearSpan = Object.values(this.energyAnalysisData.data.tableData.year)[0].cool.length;
        for (let i = 0; i < yearSpan; i++) {
            const yearSheetData = new Array<Array<string | number>>();
            yearSheetData.push(['设备种类', '电', '热', '冷', '汽']);
            Object.keys(this.energyAnalysisData.data.tableData.year).forEach((key) => {
                yearSheetData.push([
                    key,
                    this.energyAnalysisData.data.tableData.year[key].power[i],
                    this.energyAnalysisData.data.tableData.year[key].heat[i],
                    this.energyAnalysisData.data.tableData.year[key].cool[i],
                    this.energyAnalysisData.data.tableData.year[key].steam[i],
                ]);
            });
            sheetsData.push({ name: `${startYear + i}年`, data: yearSheetData });
        }

        await Tools.exportXlsxFile(this.$route.meta?.title, sheetsData);
    }

    /**
     *开始计算
     */
    async startCal(): Promise<void> {
        try {
            this.$notification.success({
                message: '正在计算',
                key: this.$options.name,
                duration: 0,
                description: '',
                icon: this.$createElement({ template: '<a-icon type="loading" style="color: #108ee9" />' }),
            });
            await API.saveDataToclickhouse({
                simuid: this.$route.query.simu_id || 0,
                planId: this.$store.getters.getCurrentPlanId,
                CMD_TYPE: 'energyEvaluation',
            });
            await this.loadData(true);
            this.$notification.success({ message: '计算完成', key: this.$options.name, duration: 1, description: '' });
        } catch (e) {
            await this.$message.error({ content: '计算失败,错误为:' + String(e), key: '能效分析', duration: 2.5 });
            throw e;
        }
    }
    /**
     *获取当前planId
     */
    get currentPlanId(): number {
        return this.$store.getters.getCurrentPlanId;
    }
    /**
     *单次获取结果
     */
    @Watch('currentPlanId')
    async planChange(): Promise<void> {
        this.signTime = 0;
        await this.loadData();
    }

    /**
     *
     */
    @DataLoad()
    async loadData(isPolling?: boolean): Promise<void> {
        /** 加载效果，自行使用 */
        this.spinningStatus = true;
        try {
            const data = (await api_data.getTaskManagerData({ type: 'getEnergyEvaluation', id: this.$store.getters.getCurrentPlanId, time: this.signTime }))
                .results[0] as Record<string, unknown> | undefined;
            if (data == null) {
                if (isPolling) {
                    await delayedPromise(3000);
                    await this.loadData(true);
                } else {
                    this.energyAnalysisData = DefaultEnergyAnalysisData;
                }
            } else {
                this.spinningStatus = false;
                this.signTime = data.time as number;
                this.$nextTick(() => {
                    this.energyAnalysisData = data as typeof DefaultEnergyAnalysisData;
                });
            }
        } catch (e) {
            this.energyAnalysisData = DefaultEnergyAnalysisData;
            this.spinningStatus = false;
            MessageBus.Notification('error', { description: `${e}`, message: '提示' });
            throw new Error(`未知错误,${e}`);
        }
    }
    /**
     * @author guan
     * @description 开局加载数据
     * @return void
     */
    mounted(): void {
        this.loadData().catch((e) => e);
        this.disabledFunction = ieslabDisableRules;
    }
}
